export const AUTOMATION_SKIP_CHECKS_USER_AGENT = 'Automation_SkipChecks';
export const isAutomationSkipChecksUserAgent = () =>
    navigator.userAgent.includes(AUTOMATION_SKIP_CHECKS_USER_AGENT);
